import React from 'react';
import { getIdFromUrl } from '../../../utils/getIdFromUrl';
import { IDocument, IExtraction } from '../../../types/my-types';
import useDocGen from '../../hooks/useDocGen';
import ReviewContent from './ReviewContent';
import useTokenized from '../../hooks/useTokenized';
import { MarkDispatchContext, MarkStateContext } from '../../../context/MarkContext';
import { useLocation } from 'react-router';

interface ReviewDocProps {
  extraction: IExtraction;
}
// TODO: dependable queries
function ReviewDoc({ extraction }: ReviewDocProps) {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  // console.log({ extraction });
  const docId = getIdFromUrl(extraction.document);
  // extraction does not have tokenized in basic mode,
  // but have tokenized with advanced mode
  const tokenizedUrl = extraction.tokenized;
  const dispatch = React.useContext<React.Dispatch<any>>(MarkDispatchContext);
  const doc = useDocGen(docId);
  const docLabel = (doc as IDocument).label;
  const tokenPages = useTokenized(tokenizedUrl, docId, docLabel, true);

  if (tokenPages && !Array.isArray(tokenPages)) {
    return tokenPages;
  }
  if (!doc?.hasOwnProperty('id')) {
    return doc as JSX.Element;
  }

  if (doc.hasOwnProperty('id') && Array.isArray(tokenPages)) {
    setTimeout(() => {
      dispatch({ type: 'DOC_LABEL', payload: docLabel });
    }, 100);
    return (
      <ReviewContent doc={doc as IDocument} extractionId={extraction.id} tokenPages={tokenPages} />
    );
  } else {
    return null;
  }
}

export default ReviewDoc;
